const HIGHLIGHT_FILL = "#004a90";

/**
 * Busca nodos del SVG por nombre de clase (soporta acentos y mayúsculas).
 * Evita el fallback que eliminaba caracteres unicode (p. ej. Los-Ángeles → Los-ngeles).
 */
export function findMapElementsByClass(mapRoot, className) {
  const trimmed = String(className || "").trim();
  if (!trimmed || !mapRoot) return [];

  if (typeof CSS !== "undefined" && CSS.escape) {
    try {
      const nodes = mapRoot.querySelectorAll(`.${CSS.escape(trimmed)}`);
      if (nodes.length > 0) {
        return [...nodes];
      }
    } catch {
      /* continúa con búsqueda manual */
    }
  }

  const normalized = trimmed.toLowerCase();
  const candidates = mapRoot.querySelectorAll(
    ".svg-country-path, path[class], circle[class], .Italia"
  );

  return [...candidates].filter((el) => {
    const classAttr = el.getAttribute("class") || "";
    return classAttr.split(/\s+/).some((c) => c.toLowerCase() === normalized);
  });
}

export function clearInternationalMapHighlight(mapRoot) {
  if (!mapRoot) return;

  mapRoot.querySelectorAll(".is-Active").forEach((el) => {
    el.classList.remove("is-Active");
    el.removeAttribute("fill");
  });

  mapRoot.querySelectorAll(".Italia").forEach((path) => {
    path.removeAttribute("fill");
  });
}

export function applyInternationalMapHighlight(mapRoot, marker) {
  clearInternationalMapHighlight(mapRoot);

  const value = String(marker || "").trim();
  if (!value || !mapRoot) return;

  if (value === "Italia") {
    mapRoot.querySelectorAll(".Italia").forEach((path) => {
      path.setAttribute("fill", HIGHLIGHT_FILL);
    });
    return;
  }

  const tokens = value.split(/\s+/).filter(Boolean);
  const highlighted = new Set();

  tokens.forEach((token) => {
    findMapElementsByClass(mapRoot, token).forEach((el) => {
      if (highlighted.has(el)) return;
      highlighted.add(el);
      el.classList.add("is-Active");
      el.setAttribute("fill", HIGHLIGHT_FILL);
    });
  });
}
